/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MoreLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M4.5 10.5c-.83 0-1.5.68-1.5 1.5s.67 1.5 1.5 1.5S6 12.82 6 12s-.67-1.5-1.5-1.5m15 0c-.82 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5S21 12.82 21 12s-.68-1.5-1.5-1.5m-7.5 0c-.82 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.68-1.5-1.5-1.5" />
  </Icon>
);
